import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { RankIcon } from 'src/components/insights/icons/rank'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import InsightLocked from 'src/components/insight-locked'
import { useTier } from 'src/hooks/use-tier'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'

import rank1 from 'src/assets/images/insights-previews/rank/rank_1.gif'
import rank1Placeholder from 'src/assets/images/insights-previews/rank/rank_1.png'
import rank2 from 'src/assets/images/insights-previews/rank/rank_2.gif'
import rank2Placeholder from 'src/assets/images/insights-previews/rank/rank_2.png'
import rank3 from 'src/assets/images/insights-previews/rank/rank_3.gif'
import rank3Placeholder from 'src/assets/images/insights-previews/rank/rank_3.png'
import { Colors } from 'src/components/theme'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'

const RankContent = dynamic(() => import('src/components/insights/rank/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const MobilityPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  const meetsTier = useTier(INSIGHTS_TIER['Rank'])

  return (
    <InsightContainer insight={insight} color={Colors.purpleDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        {!meetsTier ? <InsightLocked insight={insight} /> : <RankContent insight={insight} />}
      </React.Suspense>
    </InsightContainer>
  )
}

export const Rank: Insight = {
  id: 'rank',
  tabId: COMMANDAI_IDS_MAP.mapExplorer['brand-rank-tab'],
  component: MobilityPage,
  name: 'Brand Rank',
  icon: RankIcon,
  supportedResultTypes: ['alphamap-location'],
  linkTooltipFile: 'insights-link-location-rank',
  tier: INSIGHTS_TIER['Rank'],
  paywall: {
    title: 'See Rank Reports in Action',
    description: `Rank isn't available on your current plan. However, you can view full functionality of this feature by viewing an unlocked location or upgrading your plan below.`,
    synopsis: [
      {
        image: rank1.src,
        imagePlaceholder: rank1Placeholder.src,
        title: 'Benchmark Like a Pro',
        description: 'Effortlessly compare locations, identifying top performers and uncovering key market trends.',
      },
      {
        image: rank2.src,
        imagePlaceholder: rank2Placeholder.src,
        title: 'Strategic Insights at Your Fingertips',
        description:
          'Make data-driven decisions with ease, using objective rankings to guide your investment and expansion strategies.',
      },
      {
        image: rank3.src,
        imagePlaceholder: rank3Placeholder.src,
        title: 'Optimize Your Market Position',
        description:
          'Leverage powerful analytics to refine your location strategy and outperform competitors in the market.',
      },
    ],
  },
}
